export { Heading, headingBlockLevelClassNames } from "./Heading"
export type { HeadingProps } from "./Heading"
